import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import AddStaffMembervalidation from "../../yup/Staff/AddStaffMember";
import Errormessages from "../ErrorMessage/Errormessages";
import CommanForm from "../FormController/Commanform";
import Button from "../Ui/Button";
import CommanPhoneNumber from "../Ui/PhoneNumber";
import { StaffMemberAddAction, StaffMemberCategoryServiceGetAction } from "../../redux/Action/StaffMemberAction";
import NewStaff from "./NewStaff";
import { validImageTypes, validateImage } from "../../utils/Helper";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import { useIntl } from 'react-intl';
import $ from "jquery"
const AddNewStaff = () => {
    const intl = useIntl();
    const local_language = localStorage.getItem('lang')

    const dispatch = useDispatch<any>();

    const service_data = useSelector((state: any) => state.StaffMemberCategoryServiceState);
    const category_data = useSelector((state: any) => state.CategoryState);

    const add_staff_member = useSelector((state: any) => state.StaffMemberAddState);
    const [newStaffComponents, setNewStaffComponents]: any = useState([1]);
    const [isServiceSelected, setIsServiceSelected] = useState(false)

    const { register, errors, handleSubmit, setValue, trigger, watch, getValues, setError, reset } = CommanForm({ validationSchema: AddStaffMembervalidation });

    const [profileImage, setProfileImage] = useState("");
    const [profileImageError, setProfileImageError] = useState("")
    const [serviceData, setServiceData] = useState([])
    const [category, setCateory] = useState<any[]>([]);
    const [image, setImage] = useState("")

    const profile_data = useSelector((state: any) => state.GetProfileState);


    const onSubmit = (payload: any) => {
        if (profileImage?.length == 0) {
            return setProfileImageError(local_language == "alb" ? "Ju lutemi zgjidhni imazhin e profilit" : "Please select profile image")
        }
        setProfileImageError("")

        let arr: any = []
        serviceData?.map((item: any) => {
            arr.push(item?.value)
        })

        const catIds = category.map((item: any) => item.catId);


        const data = {
            // category_id: JSON.stringify(catIds),
            service_id: arr ? JSON.stringify(arr) : [],
            profile_pic: image,
            owner_name: payload?.name,
            email: payload?.email,
            phone_country_code: "+" + payload?.phone_country_code,
            phone_number: payload?.phone_number,
            location: payload?.address,
            parent_id: profile_data?.data?.data?.id,
            role_id: 2
        }

        dispatch(StaffMemberAddAction(data))
    }


    const handlePhoneNumber = (value: any, code: any, phone: any) => {
        setValue('phone_country_code', code?.dialCode);
        setValue('phone_number', phone);
        trigger("phone_number")
    }



    const handleAdd = () => {
        setNewStaffComponents([...newStaffComponents, <NewStaff key={newStaffComponents.length} />]);
    };


    const handleImageAdd = (event: any) => {
        const file = event.target.files?.[0];
        if (file) {
            const validationError = validateImage(file, validImageTypes);
            if (validationError !== true) {
                toast.error(validationError);
                return;
            }
            const imageURL = URL.createObjectURL(file);
            setProfileImage(imageURL);
            setImage(file)
            setProfileImageError("")
        }
    };

    useEffect(() => {
        if (profileImage?.length == 0) {
            return setProfileImageError(local_language == "alb" ? "Ju lutemi zgjidhni imazhin e profilit" : "Please select profile image")
            // return setProfileImageError("Please select profile image")
        } else {
            setProfileImageError("")
        }
    }, []);

    const [catgoryError, setCategoryError] = useState("");

    // const handleSubmitData: any = () => {
    //     if (!isServiceSelected) {
    //         setCategoryError("Please select at least one category.")
    //     } else {
    //         setCategoryError("")

    //     }
    // }
    useEffect(() => {
        if (add_staff_member?.status) {
            $(".staff-model-box").click()
            dispatch(StaffMemberAddAction("RESET"))
        }
    }, [add_staff_member])

    useEffect(() => {
        return () => {
            dispatch(StaffMemberAddAction("RESET"))
            $('.modal-backdrop').remove();
            reset()
            setProfileImage("")
            setServiceData([])


        }
    }, [])

    const handleClose = () => {
        reset()
        setProfileImage("")
        setServiceData([])
        setNewStaffComponents([1])
        dispatch(StaffMemberAddAction("RESET"))
        dispatch(StaffMemberCategoryServiceGetAction("RESET"))
    }


    return (
        <>
            <div className="modal modelStyle fade" id="AddNewStaff" tabIndex={-1} aria-labelledby="exampleModalLabel"
                data-bs-backdrop="static" aria-hidden="true" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel"><FormattedMessage id="add_new_staff_member" /></h1>
                            <button type="button" className="btn p-0 f-20 btnClose staff-model-box" data-bs-dismiss="modal" aria-label="Close" onClick={handleClose}><span className="icon-close"></span></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className='stafPhoto text-center mb-3' >


                                    <figure>
                                        {profileImage?.length > 0 ? <img src={profileImage} alt="Profile" /> : <span className="icon-upload"></span>}
                                    </figure>

                                    <button type='button' className='btn btn-sm-outline'>
                                        <span className="icon-edit"></span>
                                        <input type="file" {...register("profile_img", { onChange: handleImageAdd })} />
                                        <FormattedMessage id="add_photo" />
                                    </button>
                                    <Errormessages errors={errors} name="profile_img" />
                                    <p className="text-danger">{profileImageError}</p>
                                </div>


                                <div className='row gy-3 placeholder-wave' >
                                    <div className='col-12'>
                                        <div className='normalINput'>
                                            <label className="form-label"><FormattedMessage id="staff_member_name" /></label>
                                            <input type="text" className="form-control"
                                                placeholder={intl.formatMessage({ id: 'enter_name' })}

                                                {...register("name")}
                                                onInput={(e: any) => {
                                                    const value = e.target.value.replace(/\s{2,}/g, ' ');
                                                    setValue("name", value);
                                                }}


                                                maxLength={15}
                                            />
                                        </div>
                                        <Errormessages errors={errors} name="name" />
                                    </div>

                                    <div className='col-sm-6'>
                                        <div className='normalINput'>
                                            <label className="form-label"><FormattedMessage id="email_address" /></label>
                                            <input type="email" className="form-control" placeholder={intl.formatMessage({ id: 'enter_email_address' })}
                                                {...register("email")} />
                                        </div>
                                        <Errormessages errors={errors} name="email" />
                                    </div>

                                    <div className='col-sm-6'>
                                        <div className='ReactnormalINput'>
                                            <label className="form-label"><FormattedMessage id="phone" /></label>
                                            <CommanPhoneNumber handleMobileNumber={handlePhoneNumber} value={`${watch('phone_country_code')}${watch('phone_number')}`} />
                                        </div>
                                        <Errormessages errors={errors} name="phone_number" />
                                    </div>

                                    <div className='col-12'>
                                        <div className='normalINput'>
                                            <label className="form-label"><FormattedMessage id="address" /></label>
                                            <input type="text" className="form-control" placeholder={intl.formatMessage({ id: 'enter_address' })}
                                                {...register("address")}
                                                onInput={(e: any) => {
                                                    const value = e.target.value.replace(/\s{2,}/g, ' ');
                                                    setValue("address", value);
                                                }}

                                            />
                                        </div>
                                        <Errormessages errors={errors} name="address" />

                                    </div>
                                    {newStaffComponents &&
                                        <NewStaff
                                            setIsServiceSelected={setIsServiceSelected}
                                            newStaffComponents={newStaffComponents}
                                            watch={watch}
                                            register={register}
                                            // handleSubmitData={handleSubmitData}
                                            // catgoryError={catgoryError}
                                            // setCategoryError={setCategoryError}
                                            setService={setServiceData}
                                            setCateory={setCateory}
                                        />
                                    }

                                </div>
                                <div className='text-center my-4'><span role='button' className='link' onClick={handleAdd}>+{<FormattedMessage id="add_new" />}</span></div>
                                <Button type="submit" className="btn btn-fill w-100" text={<FormattedMessage id="Save" /> as any} isLoading={add_staff_member?.loading} />
                                {/* <Button type="submit" className="btn btn-fill w-100" text="Save" onClick={() => handleSubmitData} isLoading={add_staff_member?.loading} /> */}
                            </form>
                        </div>
                    </div>
                </div >
            </div >
        </>
    )
}

export default AddNewStaff
